import React, { useRef, useState, useCallback, useEffect, useImperativeHandle } from 'react'

import moment from 'moment';

import ReactDataGrid from '@inovua/reactdatagrid-community';
import '@inovua/reactdatagrid-community/index.css'

// import NumberFilter from '@inovua/reactdatagrid-community/NumberFilter'
// import SelectFilter from '@inovua/reactdatagrid-community/SelectFilter'
// import BoolFilter from '@inovua/reactdatagrid-community/BoolFilter'

// import NumberFilter from '@inovua/reactdatagrid-community/NumberFilter'
// import SelectFilter from '@inovua/reactdatagrid-community/SelectFilter'
// import DateFilter from '@inovua/reactdatagrid-community/DateFilter'


const DataGridTable = React.forwardRef((props, ref) => {

    const [gridRef, setGridRef] = useState()

    const {
        refresh,
        fetchData,
        dataGrid,
    } = props;

    let {
        style
    } = dataGrid;

    const {
        idProperty,
        columns,
        defaultFilterValue,
        skipAllSearch = false,
        checkboxColumn,
        defaultLimit = 10,
        defaultSkip = 0,
        pageSizes = [10, 20, 50, 100],
        skip,
        onSelectionChange,
        onSkipChange = () => { },
        showCellBorders = false,
        handleOnLoad = () => { },
        className = '',
        // filterTypes
    } = dataGrid

    window.moment = moment

    const [selected, setSelected] = useState({});

    const dataSource = useCallback(fetchData, [refresh])

    const dataMap =
        gridRef && gridRef.current && gridRef.current.dataMap
            ? gridRef.current.dataMap
            : null;

    style = { ...style, border: '1px none #000', minHeight: 600 }

    if (columns)
        columns.map(item => {
            item.headerProps = {
                style: {
                    border: '1px none #000'
                }
            }
            return false;
        })

    const toArray = (selected, dataMap) => {

        // console.log('dataMap', dataMap)

        if (!dataMap) return [];

        const keysObj = selected === true ? dataMap : selected;
        // return Object.keys(keysObj).map(key => Number(key))
        return Object.keys(keysObj).map(key => (key))
    }

    ReactDataGrid.defaultProps.filterTypes = {
        string: {
            type: 'string',
            emptyValue: '',
            operators: [
                // {
                //     name: 'contains',
                //     fn: ({ value, filterValue, data }) => {
                //     return !filterValue ?
                //         true :
                //         value.indexOf(filterValue) != -1;
                //     }
                // },
                {
                    name: 'eq',
                    fn: ({ value, filterValue }) => value === filterValue
                },
                {
                    name: 'startsWith',
                    fn: ({ value, filterValue }) => value !== filterValue
                },
                {
                    name: 'endsWith',
                    fn: ({ value, filterValue }) => value !== filterValue
                },
                {
                    name: 'contains',
                    fn: ({ value, filterValue }) => value === filterValue
                },
            ]
        },
        // boolean: {
        //     type: 'boolean',
        //     operators: [...]
        //     }
    }

    const _onSelectionChange = useCallback((props) => {
        // console.log('selected >> ', props)
        setSelected(props?.selected)
        // setUnselected(props?.unselected)
    }, []);

    useEffect(() => {

        if (onSelectionChange) {

            // getting the data details
            let selectedDatas = []

            // console.log('selected, selected', selected)

            if (selected === true) { // if select all checkbox
                Object.keys(dataMap).forEach(i => {
                    // console.log('selectedDatas ---> ', selectedDatas, dataMap, i)
                    selectedDatas.push(dataMap[i])
                })
            } else {
                Object.keys(selected).forEach(i => {
                    // console.log('selectedDatas ---> ', selectedDatas, dataMap, i)
                    selectedDatas.push(dataMap[i])
                })
            }

            onSelectionChange(
                toArray(selected, dataMap),
                selectedDatas
            )
        }

    }, [selected])

    const onReady = (ref) => {

        setGridRef(ref)

        if (handleOnLoad) {
            handleOnLoad({ ref })
        }
    }

    const RenderMain = () => {


        if (!defaultFilterValue) return <></>
        if (!columns) return <></>

        // console.log('defaultFilterValue --> ', defaultFilterValue.length)

        if (defaultFilterValue.length <= 1) return <></> // must more than 1

        let a = {
            defaultFilterValue
        }

        if (skipAllSearch === true) a = {}

        return (
            <ReactDataGrid
                // handle={ref => gridRef?.current === ref ? ref.current : null}
                // onReady={setGridRef}
                onReady={onReady}
                // handle={setGridRef}

                idProperty={idProperty}
                style={style}
                // defaultFilterValue={defaultFilterValue}
                {...a}
                columns={columns}
                checkboxColumn={checkboxColumn}
                defaultLimit={defaultLimit}
                defaultSkip={defaultSkip ? defaultLimit : 0}
                pageSizes={pageSizes}
                dataSource={dataSource}
                pagination
                skip={skip}
                // onFilterValueChange={setFilterValue}
                selected={selected}
                // unselected={unselected}
                // showCellBorders={showCellBorders}
                onSelectionChange={_onSelectionChange}
                onSkipChange={onSkipChange}
                checkboxOnlyRowSelect="false"
                // renderColumnContextMenu={renderColumnContextMenu}
                // enableColumnFilterContextMenu={false}
                onEditComplete={({ value, columnId, rowId }) => {
                    // const data = [...dataSource];
                    // data[rowId][columnId] = value;

                }}
                editable={Boolean(true)}
                enableColumnAutosize={Boolean(false)}
                className={className}
            // filterTypes={filterTypes}
            />
        )
    }

    return (
        <>
            {
                RenderMain()
            }

            {/* <ReactDataGrid
            idProperty="id"
            style={gridStyle}
            defaultFilterValue={_filterValue}
            columns={columns}
            checkboxColumn
            defaultLimit={5}
            defaultSkip={0}
            pageSizes={[10, 15, 30]}
            dataSource={dataSource}
            pagination
            // onFilterValueChange={setFilterValue}
            selected={selected}
            onSelectionChange={onSelectionChange}
            // renderColumnContextMenu={renderColumnContextMenu}
            // enableColumnFilterContextMenu={false}
        /> */}

            {/* <p>Selected rows: {JSON.stringify(toArray(selected, dataMap))}</p> */}
        </>
    )

})


export default DataGridTable;